"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ImportantNotice() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="important-notice" className="w-full bg-background py-24 md:py-32" aria-label="Aviso Importante">
      <div className="container mx-auto px-4 max-w-4xl">
        
      </div>
    </section>;
}